module.exports = __webpack_public_path__ + "static/media/park.e60be2f8.jpeg";